import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Layout from '../../layout/Layout';
import { Container, Card, Modal } from 'react-bootstrap';
// import img1 from '../../assets/images/img1.png';
import img2 from '../../assets/images/img2.png';
import img3 from '../../assets/images/bbheart.webp';
import img4 from '../../assets/images/home-banner.webp';
import img5 from '../../assets/images/bbapp2.png';
import img6 from '../../assets/images/hero-mobile.webp';
import img7 from '../../assets/images/Cube.png';
import img8 from '../../assets/images/Cube-mobile.png';
import blogimg1 from '../../assets/images/blog-image1.svg';
import blogimg2 from '../../assets/images/blog-image2.svg';
import blogimg3 from '../../assets/images/blog-img3.svg';
import blogimg4 from '../../assets/images/blog-image4.svg';
import appstore from '../../assets/images/appstore.png';
import googleplay from '../../assets/images/googleplay.png';
import img from '../../assets/images/blog-banner.svg';
import space from '../../assets/images/space.png';
import beyondbox from '../../assets/images/beyondbox.png';
import infobox from '../../assets/images/infobox.png';
import visionbox from '../../assets/images/visionbox.png';
import familybox from '../../assets/images/familybox.png';
import reflectbox from '../../assets/images/reflect.png';
import publicbox from '../../assets/images/public.png';
import glowLine from '../../assets/images/bottomGlow.png';
import { Carousel } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { GoArrowRight } from "react-icons/go";
import { IoShield } from "react-icons/io5";
const Landing = () => {
  // const userAgent = navigator.userAgent;
  // const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  // const isAndroid = /android/i.test(userAgent);
  const redirectTo = useNavigate()
  const [email, setEmail] = useState('');
  const [buttonClicked, setButtonClicked] = useState(false);
  // const isWeb = !isIOS && !isAndroid;
  const [name, setName] = useState('');
  const handleSubmit = (event: any) => {
    event.preventDefault()
    if (name && email) {

      redirectTo('/signup', { state: { name, email } });
    }
    else {
      setButtonClicked(true);
    }

  }
  localStorage.clear();
  const vId: any = "DSNvXNUBHfI";

  const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  return (
    <Layout>
      {/* <button onClick={handleShow}>
        Launch demo modal
      </button>
      <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} className='modalDownloadApp'>
        <Modal.Body>
          <p className='mb-1'>
            <span><strong style={{ color: '#f7a817' }}>Congratulations!</strong></span> Your account has been activated
          </p>
          <p className='mb-5'>
            <strong>Welcome to the <span style={{ color: '#f7a817' }}>Beyond</span>Box Family!</strong>
          </p>

          {isIOS ? (
            <>
              <p className='mb-1'>
                Please <a style={{ color: '#f7a817', textDecoration: 'underline' }} href="https://apps.apple.com/us/app/beyondbox-messenger/id6448447137" target="_blank" rel="noopener noreferrer">Download</a> the App and log in to your account to continue setting up your profile...
              </p>
            </>
          ) : isAndroid ? (
            <>
              <p className='mb-1'>
                Please <a style={{ color: '#f7a817', textDecoration: 'underline' }} href="https://play.google.com/store/apps/details?id=com.beyondboxapp" target="_blank" rel="noopener noreferrer">Download</a> the App and log in to your account to continue setting up your profile...
              </p>
            </>
          ) : (
            <>
              <p className='mb-4'>Download the app to continue setting up your profile:</p>
              <div className="btnBlock text-center d-flex justify-content-center">
                <a href="https://apps.apple.com/us/app/beyondbox-messenger/id6448447137" className="appstore pointer" >
                  <img src={googleplay} alt="" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.beyondboxapp" className="googleplay">
                  <img src={appstore} alt="" />
                </a>
              </div>
            </>
          )}

          <div className='text-center mt-4'>
            <img className="app-img" src={img5} alt="Download App" />
          </div>
        </Modal.Body>
      </Modal> */}
      <div className="home-intro intro background-color container-width">
        <div className='d-lg-flex'>
          <div className="half-section">
          <div className="sm-mw-100">
          <h1 className="heading-title text-center text-xl-start">Welcome to  <br />  <span className="theme-color">Your Life Space</span></h1>
          {/* <h2 className="heading-title">Where Love Lives Forever</h2> */}
          {/* <p>Create digital boxes filled with treasured messages, memories, media and more, to be released after you have moved on from this world.</p> */}
          {/* <Link to="">Read more</Link> */}
          {/* <div className="d-flex justify-content-center">
          <Link to="/login" className="yellowBtn btn btn-primary me-4">Sign in </Link>
          <Link to="/signup" className="yellowBtn btn btn-primary">Create Profile</Link>
          </div> */}
          <div className="d-none d-xl-block">
          <div className="mb-4">
          {/* <h5 className="theme-color">Preserve Your Legacy</h5> */}
          <p className="text-white">
          <span className="theme-color">BeyondBox </span> is a life and legacy platform designed to help you reflect on your life, live with intention, and leave a meaningful legacy for the people you love.
          </p>

          <p className="text-white">
          Through beautifully crafted digital boxes, it empowers joyful, grateful, and meaningful living.
          </p>

          <div className="d-flex gap-3">
          <a className="button-secondary rounded-1" href="/signup"><span className='d-flex align-items-center'> Create My Life Space 
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#ffffff" className="bi bi-arrow-right ms-2" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
            </svg>
          </span></a>
          <a className="button-secondary-dark rounded-1" href="#boxes"><span> Explore Boxes</span></a>
          </div>
          </div>
          {/* <div className="text-start hero-content-para-cover mb-4">
          <h5 className="theme-color">Secure & Private</h5>
          <p className="text-white">
          End-to-end encryption ensures your most intimate memories and messages are securely preserved for your chosen recipients.
          </p>
          </div>
          <div className="text-start hero-content-para-cover mb-4">
          <h5 className="theme-color">Your Ultimate Gift</h5>
          <p className="text-white">
          Your treasured gifts will have an immense impact on your loved ones, aiding them in grieving, healing, and celebrating your life, guiding them through a future without you.
          </p>
          </div>
          <div className="text-start hero-content-para-cover mb-4">
          <h5 className="theme-color">A Platform For Good</h5>
          <p className="text-white">
          Join our mission to support charitable causes worldwide through the BeyondBox Foundation, extending your legacy beyond personal connections to global impact.
          </p>
          </div> */}
          </div>
          </div>
          </div>
          <div className="img-Cover landing-banner">
            <img className="img-fluid for-lg" src={img7} alt="" />
            <img className="img-fluid for-sm" src={img8} alt="" />
          </div>
        </div>
        <div className='d-block d-xl-none'>
          <div className="mb-4">
            {/* <h5 className="theme-color">Preserve Your Legacy</h5> */}
            <p className="text-white text-center">
              <span className="theme-color">BeyondBox </span> is a life and legacy platform designed to help you reflect on your life, live with intention, and leave a meaningful legacy for the people you love.
            </p>

            <p className="text-white text-center">
              Through beautifully crafted digital boxes, it empowers joyful, grateful, and meaningful living.
            </p>

            <div className="d-flex justify-content-center gap-3 mt-3">
              <a className="button-secondary rounded-3 lifeSpaceBtn" href="/signup"><span> Create My Life Space</span></a>
              <a className="button-secondary-dark rounded-3 exploreBtn" href="#boxes"><span> Discover Boxes</span></a>
            </div>
          </div>
        </div>
        <div className='form-landing d-none'>
          <form onSubmit={handleSubmit}>
            <h4 style={{ color: "white", fontWeight: 'bold' }} className="mt-2">Create timeless treasures with the <span className='theme-color'>BeyondBox</span> App</h4>
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Enter your name</label>
              <input
                type="text"
                className="form-control"

                placeholder="Name and Surname"
                value={name}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  const regex = /^[A-Za-z\s]*$/;
                  if (regex.test(inputValue)) {
                    setName(inputValue);
                  }
                }}
              />

            </div>
            <div className="form-group">
              <label htmlFor="exampleInputPassword1">Enter your email</label>
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button type="submit" className="mt-3 button-secondary font-regular btn btn-primary">
              Create Profile

            </button>

            <div className="mt-2">
              {((name === '' || email === '') && buttonClicked) && (
                <small className="form-text text-danger">
                  Please enter name and email to create profile.
                </small>
              )}
              <p style={{ color: 'whitesmoke' }}>
                {/* Already have an account? <Link to="/login">Log in</Link> */}
              </p>
            </div>
          </form>
        </div>
        <div className='secure'>
          <div className='container-width'>
            <div className='d-flex justify-content-center align-items-center gap-1'>
              <div className="glowLine right"></div>
              <div className='secureWrap d-flex justify-content-center align-items-center text-center gap-2'>
                <IoShield className='theme-color fs-4 me-1' />
                <p className='mb-0'>Secure. Private. Built on <span className='theme-color'>AWS</span> cloud infrastructure</p>
              </div>
              <div className="glowLine left"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="gift text-center text-lg-start quoteBox">
        <div className="container-width">
          <div className="row justify-content-center">
            <div className="col-xl-5">
              <p className="fs-3 fst-lg-normal lh-base mb-lg-4 text-center">“The purpose of life is not simply to exist, but to live—to experience, to grow, to love, and to leave something meaningful behind.” </p>
              <span className='d-block theme-color text-center'>- Gordon B. Hinckley</span>
            </div>

          </div>
        </div>
      </div>

      <div className="howItWorks d-flex align-items-center">
        <div className="container-width">
          <h2 className="text-center heading-title mb-2 mb-lg-0 mt-0">Where Life, Reflection and Legacy Meet</h2>
          <p className="text-center mb-4 subTitle">Discover the Beyondbox Platform</p>
          <div className="videoContainer" style={{ justifyContent: "center" }}>
            {/* <img src={youtubePlaceholder} className="App-logo" alt="logo" /> */}
            <iframe id="youtube-iframe" height='600px' src={`https://youtube.com/embed/${vId}?controls=0&showinfo=0&title=0`} allowFullScreen></iframe>
            {/* <div className="videoBlock">
              <img src={youtubePlaceholder} className="App-logo" alt="logo" /> 
            </div> */}
          </div>
          <div className='d-none d-lg-none mt-4'>
            <div className='text-start hero-content-para-cover mb-lg-4'>
              <div className='mobile-card-box'>
                <h5 className='theme-color'>Preserve Your Legacy</h5>
                <p className="text-white">Create personalized digital treasure troves, filled with your most cherished memories, life stories, and final words of love & guidance.</p>
              </div>
            </div>
            <div className='text-start hero-content-para-cover mb-lg-4'>
              <div className='mobile-card-box'>
                <h5 className='theme-color'>Secure & Private</h5>
                <p className="text-white">End-to-end encryption ensures your most intimate memories and messages are securely preserved for your chosen recipients.</p>
              </div>
            </div>
            <div className='text-start hero-content-para-cover mb-lg-4'>
              <div className='mobile-card-box'>
                <h5 className='theme-color'>Your Ultimate Gift</h5>
                <p className="text-white">Your treasured gifts will have an immense impact on your loved ones, aiding them in their grieving, healing, and celebration of your life. A guiding presence, supporting them as they navigate a future without you.</p>
              </div>
            </div>
            <div className='text-start hero-content-para-cover mb-lg-4'>
              <div className='mobile-card-box'>
                <h5 className='theme-color'>A Platform For Good</h5>
                <p className="text-white">Join us in our mission to support charitable causes through the BeyondBox Foundation. Together we can create a lasting impact on those who need it most.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="howItWorks d-flex flex-column px-4 px-lg-0" id="boxes">
          <h2 className="text-center heading-title mt-3">Boxes Designed to Shape your Life and Legacy</h2>
          <div className="visionWrap my-auto">
            <div className='d-none d-lg-block'>
              <div className="row">
                <div className="col-lg-2 col-md-6 col-sm-6">
                  <div className="card-blog card">
                    <img className="card-img-top" src={beyondbox} />
                    <div className="card-body text-center">
                      <h3 className="theme-color">Beyond</h3>
                      <p className="card-text">The ultimate gift to those
                        who matter most. Preserve
                        a lifetime of memories,
                        messages, love, and
                        guidance to be discovered
                        after your passing, offering
                        comfort, connection,
                        reassurance, and your
                        enduring presence when it
                        is needed most.</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6">
                  <div className="card-blog card">
                    <img className="card-img-top" src={infobox} />
                    <div className="card-body text-center">
                      <h3 className="theme-color">Info</h3>
                      <p className="card-text">A dedicated space for
                        guidance on your estate and
                        personal affairs. Share clear,
                        organized information with
                        chosen recipients to ease
                        administrative burdens,
                        reduce confusion, and
                        provide direction on how
                        you wish your family to
                        proceed.</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6">
                  <div className="card-blog card">
                    <img className="card-img-top" src={familybox} />
                    <div className="card-body text-center">
                      <h3 className="theme-color">Family</h3>
                      <p className="card-text">A space to preserve your
                        family's history,
                        cherished stories, and
                        shared experiences.
                        Capture the voices,
                        lessons, and traditions of
                        generations past and
                        present, carrying your
                        legacy forward with
                        meaning and connection.</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6">
                  <div className="card-blog card">
                    <img className="card-img-top" src={visionbox} />
                    <div className="card-body text-center">
                      <h3 className="theme-color">Vision</h3>
                      <p className="card-text">Capture your dreams,
                        goals, plans, and intentions
                        for your life and your
                        family's future. A
                        personalized digital vision
                        board designed to inspire
                        clarity, alignment,
                        motivation, and purposeful
                        progress toward what
                        matters most.</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6">
                  <div className="card-blog card">
                    <img className="card-img-top" src={reflectbox} />
                    <div className="card-body text-center">
                      <h3 className="theme-color">Reflect</h3>
                      <p className="card-text">A guided daily journal
                        designed for intentional
                        living. Pause to reflect
                        on each day, record
                        highlights, personal
                        notes, ratings, gratitude,
                        and set meaningful
                        intentions that shapе
                        tomorrow with clarity
                        and purpose.</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6">
                  <div className="card-blog card">
                    <img className="card-img-top" src={publicbox} />
                    <div className="card-body text-center">
                      <h3 className="theme-color">Public</h3>
                      <p className="card-text">Write the story of your
                        life within the
                        BeyondBox Box
                        Records archive.
                        Preserved for
                        generations to come
                        to discover who you
                        were, what you stood
                        for, and be inspired by
                        your journey.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* mobile view */}
            <Carousel
              slide={true}
              interval={5000}
              controls={true}
              indicators={false}
              className='d-block d-lg-none carousel-slider'>
              <Carousel.Item>
                <div className="card-blog card px-4">
                  <img className="card-img-top" src={beyondbox} />
                  <div className="card-body text-center">
                    <h3 className="theme-color">Beyond</h3>
                    <p className="card-text">The ultimate gift to those
                      who matter most. Preserve
                      a lifetime of memories,
                      messages, love, and
                      guidance to be discovered
                      after your passing, offering
                      comfort, connection,
                      reassurance, and your
                      enduring presence when it
                      is needed most.</p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="card-blog card px-4">
                  <img className="card-img-top" src={infobox} />
                  <div className="card-body text-center">
                    <h3 className="theme-color">Info</h3>
                    <p className="card-text">A dedicated space for
                      guidance on your estate and
                      personal affairs. Share clear,
                      organized information with
                      chosen recipients to ease
                      administrative burdens,
                      reduce confusion, and
                      provide direction on how
                      you wish your family to
                      proceed.</p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="card-blog card px-4">
                  <img className="card-img-top" src={familybox} />
                  <div className="card-body text-center">
                    <h3 className="theme-color">Family</h3>
                    <p className="card-text">A space to preserve your
                      family's history,
                      cherished stories, and
                      shared experiences.
                      Capture the voices,
                      lessons, and traditions of
                      generations past and
                      present, carrying your
                      legacy forward with
                      meaning and connection.</p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="card-blog card px-4">
                  <img className="card-img-top" src={visionbox} />
                  <div className="card-body text-center">
                    <h3 className="theme-color">Vision</h3>
                    <p className="card-text">Capture your dreams,
                      goals, plans, and intentions
                      for your life and your
                      family's future. A
                      personalized digital vision
                      board designed to inspire
                      clarity, alignment,
                      motivation, and purposeful
                      progress toward what
                      matters most.</p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="card-blog card px-4">
                  <img className="card-img-top" src={reflectbox} />
                  <div className="card-body text-center">
                    <h3 className="theme-color">Reflect</h3>
                    <p className="card-text">A guided daily journal
                      designed for intentional
                      living. Pause to reflect
                      on each day, record
                      highlights, personal
                      notes, ratings, gratitude,
                      and set meaningful
                      intentions that shapе
                      tomorrow with clarity
                      and purpose.</p>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="card-blog card px-4">
                  <img className="card-img-top" src={publicbox} />
                  <div className="card-body text-center">
                    <h3 className="theme-color">Public</h3>
                    <p className="card-text">Write the story of your
                      life within the
                      BeyondBox Box
                      Records archive.
                      Preserved for
                      generations to come
                      to discover who you
                      were, what you stood
                      for, and be inspired by
                      your journey.</p>
                  </div>
                </div>
              </Carousel.Item>
            </Carousel>
          </div>
          <div className="visionWrap mt-4">
            <div className="d-flex gap-4 text-center flex-wrap justify-content-center align-items-center">
              <p className="mb-0 text-white">Being creating your life space</p>
              <a className="button-secondary rounded-5 py-1 px-5" href="/signup">
                <span> Create</span>
              </a>
            </div>
          </div>
      </div>

      <div className="gift text-center text-lg-start">
        <div className="container-width">
          <div className="row flex-md-row-reverse">
            <div className="col-xl-6 pe-lg-5 text-center">
              <h2 className="heading-title mb-4 mobile-landing">An App For Life</h2>
              <img className="app-img" src={img5} alt="" />
              <div className="btnBlock mt-lg-3">
                <a href="https://apps.apple.com/us/app/beyondbox-messenger/id6448447137" className="appstore pointer col-auto">
                  <img width="120px" src={googleplay} alt="appleplay" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.beyondboxapp" className="googleplay">
                  <img width="120px" src={appstore} alt="googleplay" />
                </a>
              </div>
            </div>
            <div className="col-xl-6">
              <h2 className="heading-title mb-4 web-landing">An App For Life</h2>

              <div className='d-none d-lg-block'>
                <h4 className='theme-color'>Be Present </h4>
                <p className="mb-4">Preserve what matters while you are living it. Capture memories,
                  messages, and moments that strengthen your relationships and
                  deepen your appreciation for the time you have together.</p>

                <h4 className='theme-color'>Reflect Daily </h4>
                <p className="mb-4">Pause each day to reflect with honesty and awareness. Capture your
                  thoughts, highlights, and insights in a space designed to support
                  clarity, gratitude, and emotional wellbeing as your life unfolds.</p>

                <h4 className='theme-color'>Live With Intention </h4>
                <p className="mb-4">Pause each day to reflect with honesty and awareness. Capture your
                  thoughts, highlights, and insights in a space designed to support
                  clarity, gratitude, and emotional wellbeing as your life unfolds.</p>

                <h4 className='theme-color'>Create A Timeless Legacy </h4>
                <p className="mb-4">Leave something meaningful behind. Thoughtfully organise
                  guidance, stories, and personal reflections so your loved ones feel
                  supported, connected, and reassured long after you are gone.</p>
              </div>

              <Carousel
                slide={true}
                interval={5000}
                controls={true}
                indicators={false}
                className='d-block d-lg-none carousel-slider h-auto'>
                <Carousel.Item>
                  <div className="card-blog px-4">
                    <div className="card-body text-center">
                      <h4 className='theme-color'>Be Present </h4>
                      <p>Preserve what matters while you are living it. Capture memories,
                        messages, and moments that strengthen your relationships and
                        deepen your appreciation for the time you have together.</p>
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className="card-blog px-4">
                    <div className="card-body text-center">
                      <h4 className='theme-color'>Reflect Daily </h4>
                      <p>Pause each day to reflect with honesty and awareness. Capture your
                        thoughts, highlights, and insights in a space designed to support
                        clarity, gratitude, and emotional wellbeing as your life unfolds.</p>
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className="card-blog px-4">
                    <div className="card-body text-center">
                      <h4 className='theme-color'>Live With Intention </h4>
                      <p>Pause each day to reflect with honesty and awareness. Capture your
                        thoughts, highlights, and insights in a space designed to support
                        clarity, gratitude, and emotional wellbeing as your life unfolds.</p>
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className="card-blog px-4">
                    <div className="card-body text-center">
                      <h4 className='theme-color'>Create A Timeless Legacy </h4>
                      <p>Leave something meaningful behind. Thoughtfully organise
                        guidance, stories, and personal reflections so your loved ones feel
                        supported, connected, and reassured long after you are gone.</p>
                    </div>
                  </div>
                </Carousel.Item>

              </Carousel>

              {/* <Link to="/view-plans" className="planBtn"><span>View Plans</span></Link> */}
              {/* <div className="btnBlock mt-5 web-landing ">
                <a href="https://apps.apple.com/us/app/beyondbox-messenger/id6448447137" className="appstore pointer col-auto">
                  <img src={googleplay} alt="appleplay" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.beyondboxapp" className="googleplay">
                  <img src={appstore} alt="googleplay" />
                </a>
              </div> */}
            </div>

          </div>
        </div>
      </div>
      {/* <div className="gift text-center text-lg-start">
        <div className="container-width">
          <div className="row flex-md-row-reverse">
            <div className="col-xl-6 pe-lg-5 text-center">
              <h2 className="heading-title mb-4 mobile-landing" style={{ textAlign: 'center' }}>A Safe Space Philosophy</h2>
              <img className="img-fluid my-3 mx-auto radiusImg d-block" src={space} alt="" />
            </div>

            <div className="col-xl-6">
              <h2 className="heading-title mb-4 web-landing " style={{ textAlign: 'center' }}>A Safe Space Philosophy
              </h2>
              <p className="para-heart-img mobile-card-box mb-lg-4">At BeyondBox, our mission is to preserve your cherished memories and personal legacy in a secure environment. This commitment is embodied in our Safe Space Philosophy, a unique approach to data security that prioritizes your peace of mind. By promoting the storage of non-sensitive information and designing the platform in a way that enables this practice, we reduce the risk of cyber threats and make BeyondBox less attractive to potential attackers. This innovative approach, together with robust security measures like end-to-end encryption and multi-factor authentication, aims to provide a sanctuary for you to confidently create, preserve, and share your legacy with the ones who matter most.</p>
              <div className="text-center mt-3"><Link to="/blog" className="button-secondary" ><span>Learn More</span></Link></div>
            </div>

          </div>
        </div>
      </div> */}
      {/*  */}
      {/* <div className="gift text-center text-lg-start">
        <div className="container-width">
          <div className="row flex-md-row-reverse">
            <div className="col-xl-6 pe-lg-5 text-center">
              <h2 className="heading-title mb-4 mobile-landing" style={{ textAlign: 'center' }}>"Live Before You Leave"<br></br><span >The<span className="theme-color">Beyond</span>Box<b>Blog</b></span></h2>
              <img className="img-fluid my-3 mx-auto radiusImg d-block  w-100" src={img} alt="" />
            </div>
            <div className="col-xl-6">
              <h2 className="heading-title mb-4 web-landing" style={{ textAlign: 'center' }}>"Live Before You Leave"<br></br><span >The<span className="theme-color">Beyond</span>Box<b>Blog</b>
              </span></h2>
              <p className="para-heart-img mobile-card-box mb-lg-4">Live Before You Leave captures the essence of BeyondBox's mission to foster a community united by a shared appreciation for the preciousness of life. On this blog,you will find content crafted to educate,enlighten, and inspire you to live joyfully and create memories and stories that will shape the legacy you choose to leave behind.</p>
              <div className="text-center mt-3"><Link to="/blog" className="button-secondary" ><span>Explore</span></Link></div>
            </div>

          </div>
        </div>
      </div> */}

      {/*  */}

      {/* <div className="download" style={{ display: 'none' }}>
        <Container>
          <h2>Get the BeyondBox App</h2>
          <div className="image">
            <img className="img-fluid" src={img2} alt="" />
          </div>
          <div className="btnBlock text-center">
            <Link to="https://apps.apple.com/us/app/beyondbox-messenger/id6448447137" className="appstore pointer col-auto" >
              <img src={appstore} alt="" />
            </Link>
            <Link to="https://play.google.com/store/apps/details?id=com.beyondboxapp" className="googleplay">
              <img src={googleplay} alt="" />
            </Link>
          </div>
        </Container>
      </div> */}

      {/* <div className="gift text-center text-lg-start">
        <div className="container-width">
          <div className="row align-items-center flex-md-row-reverse">
            <div className="col-lg-6">
              <h2 className="heading-sub-title mobile-landing">The Heart of <span className="theme-color">Beyond</span>Box</h2>
              <img className="img-fluid radiusImg" src={img3} alt="" />
            </div>
            <div className="col-lg-6">
              <h2 className="heading-sub-title web-landing">The Heart of <span className="theme-color">Beyond</span>Box</h2>
             
              <p className="para-heart-img mobile-card-box mb-lg-4">At BeyondBox, our commitment goes beyond helping
                you leave a legacy; it's about making a tangible
                difference in the world. We proudly allocate a third of
                our net earnings to the BeyondBox Foundation,
                directly linking the success of the BeyondBox
                platform to the support of vital humanitarian causes.
                With every BeyondBox you create, you're not just
                crafting memories for your loved ones; you're also
                empowering a network of partner charities to make
                impactful strides in their communities. Explore the
                stories of change on our Foundation page and join us
                in our journey to create a better world, one
                BeyondBox at a time.</p>
              <div className="text-center mt-3">
                <Link to="/foundation" className="button-secondary"><span> Learn More</span></Link>
              </div>

            </div>
          </div>
        </div>
      </div> */}

      <div className="d-flex flex-column howItWorks bottomQuote px-2 px-lg-4">
          <h2 className="text-center heading-title lh-base quoteText px-lg-0 px-2">Live Fully <br /> Love Deeply <br /> <span className="theme-color">Leave Something Beautiful</span></h2>

          {/* desktop view */}
          {/* <div className='d-none d-lg-block'>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6 ">
                <Card className="card-blog">
                  <Card.Img variant="top" src={blogimg1} />
                  <Card.Body>
                    <Card.Text>
                      BeyondBox empowers you to create a lasting legacy, motivating you to cherish every moment and share your life's wisdom and love
                      with your loved ones, even after you're gone.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 ">
                <Card className="card-blog">
                  <Card.Img variant="top" src={blogimg2} />
                  <Card.Body>
                    <Card.Text>
                      Leave personalized, encrypted digital boxes filled with your messages, guiding and comforting your loved ones through their life's journey after your passing.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 ">
                <Card className="card-blog">
                  <Card.Img variant="top" src={blogimg3} />
                  <Card.Body>
                    <Card.Text> Make use of our unique 'Public Box' feature to leave a final message to the world, celebrating your life and sharing your story on a global stage.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 ">
                <Card className="card-blog">
                  <Card.Img variant="top" src={blogimg4} />
                  <Card.Body>
                    <Card.Text>
                      BeyondBox is not just about the end; it's a tool to remind us of the preciousness of life, encouraging us to live fully and leave a meaningful impact on those we care about.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div> */}
          {/* mobile view */}
          {/* <Carousel
            slide={true}
            interval={5000}
            controls={true}
            indicators={false}
            className='d-block d-lg-none carousel-slider'>
            <Carousel.Item>
              <Card className="card-blog">
                <Card.Img variant="top" src={blogimg1} />
                <Card.Body>
                  <Card.Text>
                    BeyondBox empowers you to create a lasting legacy, motivating you to cherish every moment and share your life's wisdom and love
                    with your loved ones, even after you're gone.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="card-blog">
                <Card.Img variant="top" src={blogimg2} />
                <Card.Body>
                  <Card.Text>
                    Leave personalized, encrypted digital boxes filled with your messages, guiding and comforting your loved ones through their life's journey after your passing.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="card-blog">
                <Card.Img variant="top" src={blogimg3} />
                <Card.Body>
                  <Card.Text> Make use of our unique 'Public Box' feature to leave a final message to the world, celebrating your life and sharing your story on a global stage.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="card-blog">
                <Card.Img variant="top" src={blogimg4} />
                <Card.Body>
                  <Card.Text>
                    BeyondBox is not just about the end; it's a tool to remind us of the preciousness of life, encouraging us to live fully and leave a meaningful impact on those we care about.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Carousel.Item>
          </Carousel> */}
          <div>
            <div className="d-flex flex-wrap gap-4 text-center justify-content-center align-items-center mt-5 pt-5 createBoxText">
            <p className="mb-0 text-white fs-4">Create your <span className="theme-color">Beyond</span>Box today</p>

            <Link to="/signup" className="button-secondary rounded-5 py-1 px-5"><span> Sign Up</span></Link>
          </div>

          <div className="glowingLine my-5">
            <img className='d-block' src={glowLine} alt="" />
          </div>
          </div>
      </div>
    </Layout>

  );
};

export default Landing;